import { Injectable, Injector } from "@angular/core";
import { EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { AbstractRepositoryV2 } from "src/app/modules/core/service/v2/abstractRepositoryV2";
import { PrescriptionDefinitionModel } from "../../../api/entity/prescriptionDefinition.model";

@Injectable({
    providedIn: 'root'
})
export class PrescriptionDefinitionRepository extends AbstractRepositoryV2<PrescriptionDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PrescriptionDefinition', serviceElementsFactory, injector);
    }
}